export default "__VITE_ASSET__lkGtt5ro__"